export class ICartSuccess {
  public readonly status = 'OK';
}
